module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/logo1.f6a09e3e.png";